export default (theme) => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 0),
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
  },
  heading: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    margin: 0,
    flex: 1,
  },
  headingWithBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.0),
    marginBottom:'5px'
  },
  headingText: {
    color: 'var(--Navy---navy-main, #061E44)',
    leadingTrim: 'both',
    textEdge: 'cap',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },
  badge: {
    marginLeft: theme.spacing(0.5),
    marginTop:'4px',
    '& .MuiBadge-badge': {
      fontSize: '0.75rem',
      fontWeight: 500,
      borderRadius: '12px',
      padding: '2px 8px',
      minWidth: '20px',
      height: '20px',
      transform: 'scale(1) translate(60%, -50%)',
      backgroundColor: '#624CA5',
      color: '#FFFFFF',
    },
  },
  bodyInfoContainer: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 0),
  },
  bodyInfoText: {
    color: "#333333",
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});